import React from "react"
import * as styles from "./Styles/Terms.module.scss"
import Icon from "../Utils/Icon"

const Term: React.FC = () => (
  <div className="l-section-background--admin">
    <div>
      <div className={styles.termsWrapper}>
        <div>
          <Link
            anchorText="ロコガイド情報配信サービス利用規約"
            url="https://locoguide.jp/services/assets/pdf/terms_of_service.pdf"
          />
        </div>
        <hr className={styles.separator} />
        <div>
          <Link
            anchorText="混雑ランプサービス利用規約"
            url="https://static.tokubai.co.jp/terms/crowd_lamp.html"
          />
        </div>
      </div>
    </div>
  </div>
)

const Link = ({ url, anchorText }) => (
  <a href={url} target="_blank">
    {anchorText}
    <Icon
      className={styles.editIcon}
      type="feather"
      name="external-link"
      attr={{ width: 14, height: 14 }}
    />
  </a>
)
export default Term
